const accountDirectory = 'account'
const portalDirectory = 'internal'

export { accountDirectory, portalDirectory }
